<template>
  <div class="tw:sm:mx-4 tw:lg:mx-0 tw:w-full">
    <div v-if="initialDataLoading" class="tw:rounded-xl tw:animate-pulse tw:bg-gray-300 tw:h-[658px]"></div>
    <div v-else-if="requiredDataHasErrors">
      <DataErrorView />
    </div>

    <PerformanceStatsWrapper
      selectedPerformanceArea="bookings"
      v-else
      :markets="partnerMarkets"
      :currentCampaignType="currentCampaignType"
    />
    <FullScreenLoader v-show="requiredDataIsBeingRefetched" />
  </div>
</template>

<script setup lang="ts">
import { computed, type ComputedRef } from 'vue'

import PerformanceStatsWrapper from '@/components/rateConnect/performance/PerformanceStatsWrapper.vue'
import FullScreenLoader from '@/components/base/loaders/FullScreenLoader.vue'
import DataErrorView from '@/components/rateConnect/performance/DataErrorView.vue'

import { useSessionValues } from '@/composables/useSessionValues'
import { useCampaign, usePartnerMarkets, usePartners } from '@/components/rateConnect/queries'
import { selectedAccommodationId } from '@/layouts/queries'

const { language } = useSessionValues()

const {
  isFetching: isCampaignFetching,
  isLoading: isCampaignLoading,
  isError: isCampaignError,
  currentCampaignType,
  currentPartner,
} = useCampaign(selectedAccommodationId)

const {
  isFetching: isPartnersFetching,
  isLoading: isPartnersLoading,
  isError: isPartnersError,
} = usePartners(selectedAccommodationId)

const {
  isFetching: isMarketsFetching,
  isInitialLoading: isMarketsLoading,
  isError: isMarketsError,
  partnerMarkets,
} = usePartnerMarkets(selectedAccommodationId, language, currentPartner)

const initialDataLoading: ComputedRef<boolean> = computed(
  () => isPartnersLoading.value || isMarketsLoading.value || isCampaignLoading.value
)

const requiredDataHasErrors: ComputedRef<boolean> = computed(
  () => isPartnersError.value || isMarketsError.value || isCampaignError.value
)

const requiredDataIsBeingRefetched: ComputedRef<boolean> = computed(
  () => !initialDataLoading.value && (isPartnersFetching.value || isMarketsFetching.value || isCampaignFetching.value)
)
</script>
